import React from "react";
import { Card, CardBody } from "reactstrap";

import { ReactComponent as EmpSync } from "assets/img/svg/empSync.svg";
import { ReactComponent as NeedAccess } from "assets/img/svg/needAccess.svg";
import { ReactComponent as Employees } from "assets/img/svg/employees.svg";
import { ReactComponent as TotalUsers } from "assets/img/svg/totalUsers.svg";

const UserAnalytics = ({ userAnalytics }) => {
  const {
    honoEmployeeCount = "-",
    totalEmployeeCount = "-",
    totalEmployeeWithUserCount = "-",
    employeeNeedAccess = "-",
  } = userAnalytics;

  return (
    <div className="d-flex align-items-center justify-content-around">
      <Card
        className="mx-3 my-4 rounded-3 flex-grow-1"
        style={{ minHeight: "85px" }}
      >
        <CardBody className="px-3 py-2 d-flex align-items-center justify-content-between">
          <div>
            <div className="text-bold text-xl" style={{ color: "#235AF3" }}>
              {honoEmployeeCount}
            </div>
            <div className="text-xs text-bold">Employees Synced via HONO</div>
            {/* <div style={{ fontSize: "10px" }}>Last updated today at 12 PM</div> */}
          </div>
          <div>
            <EmpSync />
          </div>
        </CardBody>
      </Card>

      <Card
        className="mr-3 my-4 rounded-3 flex-grow-1 h-full"
        style={{ minHeight: "85px" }}
      >
        <CardBody className="px-3 py-2 d-flex align-items-center justify-content-between">
          <div>
            <div className="text-bold text-xl" style={{ color: "#D29822" }}>
              {employeeNeedAccess}
            </div>
            <div className="text-xs text-bold">Needs Access</div>
          </div>
          <div>
            <NeedAccess />
          </div>
        </CardBody>
      </Card>

      <Card
        className="my-4 rounded-3 flex-grow-1"
        style={{ minHeight: "85px" }}
      >
        <CardBody className="px-3 py-2 d-flex align-items-center justify-content-between">
          <div>
            <div className="text-bold text-xl" style={{ color: "#07794C" }}>
              {totalEmployeeCount}
            </div>
            <div className="text-xs text-bold">Total Employees</div>
          </div>
          <div>
            <Employees />
          </div>
        </CardBody>
      </Card>

      <Card
        className="mx-3 my-4 rounded-3 flex-grow-1"
        style={{ minHeight: "85px" }}
      >
        <CardBody className="px-3 py-2 d-flex align-items-center justify-content-between">
          <div>
            <div className="text-bold text-xl">
              {totalEmployeeWithUserCount}
            </div>
            <div className="text-xs text-bold">Total Users</div>
          </div>
          <div>
            <TotalUsers />
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default UserAnalytics;
